export enum PageTitle {
    InvoiceDownloadView = "Invoice Download | Enterprise DLT Payment Service",
    ArchitectView = "Architect | Enterprise DLT Payment Service",
    LoginForm = "Login | Enterprise DLT Payment Service",
    ValidateOtpForm = "Validate 2FA | Login | Enterprise DLT Payment Service",
    ForgotPasswordForm = "Forgot Password | Enterprise DLT Payment Service",
    SetupOtpForm = "Setup 2FA | Login | Enterprise DLT Payment Service",
    ResetPasswordView = "Reset Password | Enterprise DLT Payment Service",
    AccountView = "Account | Enterprise DLT Payment Service",
    CreateAccountView = "Create | Account | Enterprise DLT Payment Service",
    AccountDetailView = "Detail | Account | Enterprise DLT Payment Service",
    EditAccountView = "Edit | Account | Enterprise DLT Payment Service",
    EditClaimView = "Edit | Claim | Enterprise DLT Payment Service",
    ClaimDetailView = "Detail | Claim | Enterprise DLT Payment Service",
    NewClaimView = "New | Claim | Enterprise DLT Payment Service",
    NewInvoiceView = "New | Invoice | Enterprise DLT Payment Service",
    CollectionView = "Collection | Enterprise DLT Payment Service",
    ManageProjectAccountView = "Manage Project Account | Collection | Enterprise DLT Payment Service",
    ProjectAccountView = "Account | Project | Collection | Enterprise DLT Payment Service",
    ReceiptDetailView = "Detail | Receipt | Collection | Enterprise DLT Payment Service",
    CreateNewProfileView = "Create New Profile | Profile | Enterprise DLT Payment Service",
    ProfileDetailView = "Detail | Profile | Enterprise DLT Payment Service",
    ProfileManageMentView = "Profile | Enterprise DLT Payment Service",
    EditInvoiceView = "Edit | Invoice | Enterprise DLT Payment Service",
    InvoiceDetailView = "Invoice | Enterprise DLT Payment Service",
    NewPaymentView = "New Payment | Invoice | Enterprise DLT Payment Service",
    EditProjectView = "Edit | Project | Enterprise DLT Payment Service",
    NewProjectView = "New | Project | Enterprise DLT Payment Service",
    ProjectDetailView = "Project | Enterprise DLT Payment Service",
    ProjectOverview = "Project | Enterprise DLT Payment Service",
    UserActivityLogView = "User Activity Log | Enterprise DLT Payment Service",
    CreateNewUserView = "Create | User | Enterprise DLT Payment Service",
    UpdateUserView = "Update | Info | User | Enterprise DLT Payment Service",
    UserInformationView = "Info | User | Enterprise DLT Payment Service",
    UserManagementView = "User | Enterprise DLT Payment Service",
    HSBCOperatorInvoiceDetailView = "Detail | Invoices | Enterprise DLT Payment Service",
    InvoiceListFullView = "Invoices | Enterprise DLT Payment Service",
    DeveloperView = "Developer | Enterprise DLT Payment Service",
    PlatformAgreementView = "Platform Agreement | Enterprise DLT Payment Service"
}